import * as React from "react";

interface OtherwiseProps {
    children?: React.ReactNode;
}

export function Otherwise(props: OtherwiseProps): JSX.Element {
    return <span>{props.children}</span>;
}
